import { Text } from '@capsicum/common-web';
import { useNCWFallbackBalance } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

export const NCWFallbackBalance = () => {
	const { fallbackBalanceDescription, fallbackBalanceTitle } = useNCWFallbackBalance();

	return (
		<S.Wrapper>
			<Text color="main.enabled" variant="title1">
				{fallbackBalanceTitle}
			</Text>
			<Text color="main.enabled" variant="text4">
				{fallbackBalanceDescription}
			</Text>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		flex-direction: column;
		padding: ${({ theme }) =>
			`${theme.spacings.large} ${theme.spacings.large} ${theme.spacings.xxxsmall} ${theme.spacings.large}`};
		color: ${({ theme }) => theme.colors.backgrounds.main.container};
		gap: ${({ theme }) => theme.spacings.small};
		text-align: center;
	`;
}
